import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "yes--sprite",
  "use": "yes--sprite-usage",
  "viewBox": "0 0 13 10",
  "content": "<symbol viewBox=\"0 0 13 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"yes--sprite\">\n    <path d=\"M4.5001 7.7799L1.7201 4.9999L0.773438 5.9399L4.5001 9.66656L12.5001 1.66656L11.5601 0.726562L4.5001 7.7799Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol